import { Home } from "./pages/Home";
import { Setup } from "./pages/Setup";
import { Playlist } from "./pages/Playlist";
import Device from "./pages/Device";
import { Account } from "./pages/Account";
import { Register } from "./pages/Register";
import { Manufacture } from "./pages/Manufacture";
import { Location } from "./pages/Location";
import { History } from "./pages/History";
import { Schedule } from "./pages/Schedule";
import { Group } from "./pages/Group";

const AppRoutes = [
    {
        index: true,
        element: <Home />,
    },
    {
        path: "/setup",
        element: <Setup />,
    },
    {
        path: "/playlists",
        element: <Playlist />,
    },
    {
        path: "/devices",
        element: <Device />,
    },
    {
        path: "/account",
        element: <Account />,
    },
    {
        path: "/register",
        element: <Register />,
    },
    {
        path: "/manufacture",
        element: <Manufacture />,
    },
    {
        path: "/location",
        element: <Location />,
    },
    {
        path: "/history",
        element: <History />,
    },
    {
        path: "/schedule",
        element: <Schedule />,
    },
    {
        path: "/groups",
        element: <Group />,
    },
];

export default AppRoutes;
